/****************************************************************
 * File: pd-breadcrumb.tsx
 * Description: breadcrumb component
 * Author: zayfen <zhangyunfeng@pudutech.com>
 * Created: 2022/05/26 22:14
 *
 * History:
 *   Date               Programmer ID    Description
 *  -----------------  ---------------  ------------------------
 *  2022/05/26 22:14   zayfen           Init
 *
 * This unpublished material is proprietary to PuduTech.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of PuduTech.
 *****************************************************************/

import Link, { LinkProps } from 'next/link'
import { FC } from 'react'

type Href = Pick<LinkProps, 'href'>

export interface BreadcrumbProps {
  onlyTopBreadreumb?: boolean
  linkList: Array<Href & { label: string }>
}

const PdBreadcrumb: FC<BreadcrumbProps> = ({ linkList, onlyTopBreadreumb }) => {
  const sliceEnd = onlyTopBreadreumb ? 1 : linkList.length
  const filteredLinkList = linkList.slice(0, sliceEnd)

  return (
    <div className="flex">
      {filteredLinkList.map((item, index) => (
        <Link key={'' + item.href + index} href={item.href}>
          <span
            className={[
              'relative text-sm font-normal',
              item.href === '#' || !item.href ? '' : 'cursor-pointer',
              onlyTopBreadreumb
                ? 'pl-4 before:absolute before:left-1 before:content-[url(/icons/icon_left_arrow.svg)]'
                : '',
              index < filteredLinkList.length - 1
                ? ' text-black/60  pr-4 after:absolute after:right-1 after:content-[url(/icons/icon_right_arrow.svg)]'
                : ' text-black/90',
            ].join(' ')}
          >
            {item.label}
          </span>
        </Link>
      ))}
    </div>
  )
}

export default PdBreadcrumb
